import { getDisplayName } from '../../utils/form-helpers';
import type { IRootState } from '../root-reducer';

export const getCustomer = (state: IRootState) => state.customerApi?.customer;
export const getCustomerBranch = (state: IRootState) => state.customerApi?.customerBranch;
export const getPersonFirstName = (state: IRootState) => state.customerApi?.customer?.firstName;
export const getPersonLastName = (state: IRootState) => state.customerApi?.customer?.lastName;
export const getPersonDisplayName = (state: IRootState) => getDisplayName(state.customerApi?.customer);
